/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Provider } from 'mobx-react';
import Footer from 'blocks/Footer';
import DebugComponents from 'blocks/DebugComponents';
import NavigationAwarePageContent from 'blocks/NavigationAwarePageContent';
import CookiesModal from 'blocks/CookiesModal/CookiesModal';
import CoreStore from 'stores/Core.store';

import LayoutWrapper from './LayoutWrapper';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.coreStore = new CoreStore();
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        navigationStore={this.coreStore.navigationStore}
        windowStore={this.coreStore.windowStore}
        productsStore={this.coreStore.productsStore}
        calculatorStore={this.coreStore.calculatorStore}
        blogStore={this.coreStore.blogStore}
        forInvestorsStore={this.coreStore.forInvestorsStore}
        globalMetaTagsStore={this.coreStore.globalMetaTagsStore}
        coreStore={this.coreStore}
      >
        <LayoutWrapper>
          {children}
          <NavigationAwarePageContent>
            <Footer />
          </NavigationAwarePageContent>
          <CookiesModal />
          <DebugComponents />
        </LayoutWrapper>
      </Provider>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/blocks/Layout/index.jsx